// Los leads de la landing guardan en c_contactos la ETIQUETA del formulario
// ("Estética / Spa", "Peluquería / Barbería"), no la clave canónica del CRM
// ("estetica", "peluquerias"). El simulador indexa todo por clave, así que al
// entrar desde la ficha hay que normalizar o se pierden features enteras (el
// botón "Simular cita" desaparecía — incidente Bella luce, 2/9/2026).
// Mismo patrón que aws_lambdas/_shared_demo/resumenPoster.js.

// minúsculas, sin acentos, sin espacios sobrantes
function normalize(raw) {
  return String(raw == null ? "" : raw)
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();
}

// Etiquetas de apps/landing/components/DemoRequestForm.tsx → clave del simulador.
const LABEL_TO_SECTOR = {
  "peluqueria / barberia": "peluquerias",
  "estetica / spa": "estetica",
  "taller mecanico / lavadero": "lavadero",
  "clinica / salud": "salud",
  "fisioterapia / osteopatia": "fisioterapia",
  "tatuajes / piercing": "tatuajes",
  "peluqueria canina": "canina",
  "estetica canina": "canina",
};

// Desconocido → tal cual (mismo comportamiento que antes: sin inventar claves).
export function canonicalSimulatorSector(raw) {
  return LABEL_TO_SECTOR[normalize(raw)] || raw;
}
